export type DownloadRemoteFileOptions = {
  filename?: string
  /** @deprecated Direct attachment downloads do not use the system share sheet. */
  preferShare?: boolean
}

/**
 * @deprecated Direct attachment downloads need no browser-side prefetch.
 * Kept as a compatibility no-op for existing SDK consumers.
 */
export async function prefetchRemoteFile(url: string): Promise<boolean> {
  return Boolean(url.trim())
}

/** @deprecated Direct attachment downloads are ready as soon as their URL exists. */
export function isRemoteFilePrefetched(url: string): boolean {
  return Boolean(url.trim())
}

/** @deprecated Direct attachment downloads keep no browser-side cache. */
export function clearPrefetchedRemoteFile(_url?: string): void {
}

/**
 * Navigate directly to a remote download URL. The remote server must return
 * `Content-Disposition: attachment`; this keeps large files out of page memory
 * and lets the browser or operating-system download manager stream the response.
 */
export async function downloadRemoteFile(
  url: string,
  options: DownloadRemoteFileOptions = {},
): Promise<boolean> {
  const trimmed = url.trim()
  if (!trimmed || typeof document === 'undefined') {
    return false
  }
  const anchor = document.createElement('a')
  anchor.href = trimmed
  anchor.rel = 'noopener'
  const filename = options.filename?.trim()
  if (filename) {
    // Same-origin browsers may honor this hint; cross-origin downloads use the
    // response header or URL path for their filename.
    anchor.download = filename
  }
  anchor.style.display = 'none'
  document.body.appendChild(anchor)
  anchor.click()
  anchor.remove()
  return true
}
